<template>
    <div class="main-content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-12 heading colour-generator-heading text-uppercase text-center">
                    <h1>Choose your colour theme generator</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4 mb-5">
                    <div class="colour-theme-box">
                        <div class="colour-theme-img">
                            <router-link :to="{ name: 'Colours Fan'}" class="colour-img-bg" style="background-image: url('/assets/colour-generator/images/colour-fans.jpg');"></router-link>
                        </div>
                        <div class="colour-theme-info">
                            <h3>
                                <router-link :to="{ name: 'Colours Fan'}">Colours Fan</router-link>
                            </h3>
                            <p>Generate a monochrome colour palette and adjust it to your taste.</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 mb-5">
                    <div class="colour-theme-box">
                        <div class="colour-theme-img">
                            <router-link :to="{ name: 'Image to Colours'}" class="colour-img-bg" style="background-image: url('/assets/colour-generator/images/image-to-colours.jpg');"></router-link>
                        </div>
                        <div class="colour-theme-info">
                            <h3>
                                <router-link :to="{ name: 'Image to Colours'}">Image to Colours</router-link>
                            </h3>
                            <p>Generate a monochrome colour palette and adjust it to your taste.</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 mb-5">
                    <div class="colour-theme-box">
                        <div class="colour-theme-img">
                            <router-link :to="{ name: 'Colours Palette'}" class="colour-img-bg" style="background-image: url('/assets/colour-generator/images/palette-generator.jpg');"></router-link>
                        </div>
                        <div class="colour-theme-info">
                            <h3>
                                <router-link :to="{ name: 'Colours Palette'}">Colours Palette</router-link>
                            </h3>
                            <p>Generate a monochrome colour palette and adjust it to your taste.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    </div>

</template>

<script>
export default {
    name: "ColourGenerator",
    mounted() {
        const titleEl = document.querySelector('head title');
        titleEl.textContent = 'Colour Theme Generator - Analyst Hub by Enterprise DNA';
    }
}
</script>

<style scoped>

.colour-generator-heading h1 {
    font-size: 45px;
}
</style>
